'use strict';

/* Modules */
import auth from './auth';

import datatables from './app/datatables';
import imports from './app/imports';
import admin from './app/admin';
import settings from './app/settings';
import dynamicPages from './app/dynamic-pages';
import styles from './app/styles';
import history from './app/history'
import analytics from './app/analytics';
import superadmin from './app/superadmin';

import services from './services';
import components from './components';

/* Module */
export default angular.module('conduu.ap', [auth, datatables, admin, imports, settings, dynamicPages, styles, history,
  analytics, superadmin, services, components])
  .name;


// WEBPACK FOOTER //
// ./client/~ap/index.js